import { ContainerOutlined } from '@ant-design/icons';
import { mainLabels, mainRoutes } from 'features/main/routes';
import { logsLabels, logsRoutes } from './routes';
import { useShowLogs } from './hooks';

export const useLogsSider = () => {
  const showLogs = useShowLogs();

  if (showLogs.menu) {
    return [
      {
        // type: 'subMenu',
        label: mainLabels[mainRoutes.LOGS_V1],
        key: mainRoutes.LOGS_V1,
        icon: <ContainerOutlined />,
        children: [
          showLogs.discover && {
            label: logsLabels[logsRoutes.DISCOVER],
            key: logsRoutes.DISCOVER,
          },
          showLogs.moderators && {
            label: logsLabels[logsRoutes.MODERATORS],
            key: logsRoutes.MODERATORS,
          },
          showLogs.payment && {
            label: logsLabels[logsRoutes.PAYMENT],
            key: logsRoutes.PAYMENT,
          },
        ],
      },
    ];
  }

  return [];
};
